import {Model} from "../model";
import {FieldSection} from "./report-user-generated";
import {ReportViewType} from "./report-view-type";

export class ReportUserTemplate implements Model {
  id: string;
  loading: Promise<Model> | undefined;
  status: string;
  name: string;
  templateName: string;
  reportViewTypeId: string;
  reportViewOptions: { [key: string]: boolean } = {};
  fieldSections: FieldSection[] = [];
  reportViewType: ReportViewType
}
